export default "__VITE_ASSET__BfNGpQSy__"